module.exports = __webpack_public_path__ + "img/hotel-27.86387cd5.jpeg";